import { useEffect, useState } from 'react';
import { executeLookerQuery } from '../lib/api/looker/api';
import { useFilters } from './useFilters';

interface UseOptionsProps {
  extraExpression: string;
  view: string;
  fields: string[];
  filter?: Record<string, string>;
  pseudoAdvertiserIdFilterKey: string;
  pseudoAccountIdFilterKey: string;
  accountID: string;
  includeHcp365AccountFilter?: boolean;
}

const useOptions = ({
  extraExpression,
  view,
  fields,
  filter,
  pseudoAdvertiserIdFilterKey,
  pseudoAccountIdFilterKey,
  accountID,
  includeHcp365AccountFilter = false,
}: UseOptionsProps) => {
  const [options, setOptions] = useState<{ value: string }[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { filters } = useFilters();

  const advId = filters?.pseudo_advertiser_id_filter?.expression;
  const hcp365AccountValue = filters?.pseudo_hcp_account_suggestions_hcp365_collection?.expression;

  useEffect(() => {
    // TODO: consider using tanstack for such queries
    const fetchOptions = async () => {
      setIsLoading(true);
      const combinedFilters: Record<string, string> = {
        ...filter,
        [pseudoAdvertiserIdFilterKey]: advId,
        [pseudoAccountIdFilterKey]: accountID,
        ...(includeHcp365AccountFilter && hcp365AccountValue
          ? {
              'genome_suggestions_hcp365_collection.pseudo_hcp_account_filter': hcp365AccountValue,
            }
          : {}),
      };

      try {
        const response = await executeLookerQuery<Array<Record<string, string>>>({
          result_format: 'json',
          lookml_model_name: 'studio_hcp_audiences',
          explore_name: view,
          fields,
          filters: combinedFilters,
        });
        if (Array.isArray(response.query_result)) {
          const newOptions = response.query_result.map((item) => ({
            value: item[fields[0]],
          }));
          setOptions(newOptions);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.error('Error running inline query:', error);
        setOptions([]);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchOptions();
  }, [extraExpression]);

  return { options, isLoading };
};

export default useOptions;
